function PageHead({ title, sub, actions }) {
  return (
    <div className="page-head">
      <div className="page-head-title">
        <h1>{title}</h1>
        {sub && <div className="sub">{sub}</div>}
      </div>
      {actions && <div className="page-head-actions">{actions}</div>}
    </div>
  );
}

export default PageHead;
